import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0a56e4fe"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal_bg" }
const _hoisted_2 = { class: "modal_main" }
const _hoisted_3 = { class: "modal_contents" }
const _hoisted_4 = { class: "modal_contets_text_large" }
const _hoisted_5 = { class: "modal_contets_text_medium" }
const _hoisted_6 = { class: "modal_contents_button_column_2" }
const _hoisted_7 = { class: "modal_contents_button_column_2_inner" }
const _hoisted_8 = { class: "modal_contents_button_column_2_inner" }
const _hoisted_9 = {
  key: 0,
  class: "modal_contents_button_column_1"
}
const _hoisted_10 = { class: "modal_contents_button_column_1_inner" }

import BaseButton from '@/components/BaseButton.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseThreeButtonModal',
  props: {
  leftBtnText: {
    type: String,
    default: 'ボタン１',
  },
  leftBtnDisabled: {
    type: Boolean,
    default: false,
  },
  rightBtnText: {
    type: String,
    default: 'ボタン２',
  },
  rightBtnDisabled: {
    type: Boolean,
    default: false,
  },
  bottomBtnText: {
    type: String,
    default: 'ボタン３',
  },
  bottomBtnDisabled: {
    type: Boolean,
    default: true,
  },
},
  emits: ["leftBtnClick", "rightBtnClick", "bottomBtnClick"],
  setup(__props, { emit }: { emit: ({
  (e: 'leftBtnClick'): true;
  (e: 'rightBtnClick'): true;
  (e: 'bottomBtnClick'): true;
}), expose: any, slots: any, attrs: any }) {

const props = __props





const handleLeftBtnClick = () => {
  emit('leftBtnClick');
};

const handleRightBtnClick = () => {
  emit('rightBtnClick');
};

const handleBottomBtnClick = () => {
  emit('bottomBtnClick');
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _renderSlot(_ctx.$slots, "large")
        ]),
        _createElementVNode("div", _hoisted_5, [
          _renderSlot(_ctx.$slots, "default")
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createVNode(BaseButton, {
              theme: "primary",
              disabled: props.rightBtnDisabled,
              onClick: handleRightBtnClick
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(props.rightBtnText), 1)
              ]),
              _: 1
            }, 8, ["disabled"])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(BaseButton, {
              theme: "secondary",
              disabled: props.leftBtnDisabled,
              onClick: handleLeftBtnClick
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(props.leftBtnText), 1)
              ]),
              _: 1
            }, 8, ["disabled"])
          ])
        ]),
        (!props.bottomBtnDisabled)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("button", {
                  class: "button_text",
                  onClick: handleBottomBtnClick
                }, _toDisplayString(props.bottomBtnText), 1)
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}
}

})